<div class="column content-container">
	<div class="content-container-header">
		<h3 i18n="@@confirmation"><b>Confirmation</b></h3>
		<mat-divider></mat-divider>

		<div class="content-container-body confirmation-column">
			@if (showLoading) {
				<div>
					<mat-spinner diameter="35" style="float: left"></mat-spinner>
					<h3 style="float: left; margin-top: 7px; margin-left: 1em" i18n="@@addUser-loadingMessage">Loading...</h3>
				</div>
			}

			@if (showSuccess) {
				<div i18n="@@add-user-confirmation_message">
					This is a confirmation that <b>{{ userName }}</b> has been added to <b>{{ companyName }} </b> with a
					<b>{{ roleName }}</b> role.<br />
					<br />
					A verification email has been sent to:<br />
					<b>{{ userEmail }}</b>
				</div>
			}

			@if (showFailure) {
				<div>
					<h3 i18n="@@add-user-confirmation_error">
						Error when adding user <b>{{ userEmail }}</b> to company <b>{{ companyName }}</b> with the assigned role
						<b>{{ roleName }}.</b>
					</h3>
				</div>
			}

			<div class="button-spacing">
				<button
					mat-button
					(click)="onUserDirectoryClicked()"
					class="primary-button"
					i18n="@@returtUserDirectoryButton"
					data-automation-id="return-to-user-directory-button"
				>
					Return to User Directory
				</button>
				<button
					mat-button
					(click)="onAddUserClicked()"
					class="secondary-button"
					i18n="@@addAnotherUserButton"
					data-automation-id="add-another-user-button"
				>
					+ Add Another User
				</button>
			</div>
		</div>
	</div>
</div>
